import type { FramesClient } from "@connect/data/frames/client";
import { log } from "@connect/observability";
import type { WalletOwnershipProofBody } from "./wallet-ownership-api.types";

/**
 * Best-effort, like Orion: the buy check resolution still carries the proof, so a
 * failure here is only logged and never blocks the customer.
 */
export async function saveWalletOwnershipProof(
  client: FramesClient,
  body: WalletOwnershipProofBody,
): Promise<void> {
  try {
    const { error, response } = await client.POST("/platform/v1/partner/customer/current/wallet", {
      body,
    });
    if (error) {
      log.error("connect.challenge.wallet_ownership_proof_failed", { status: response.status });
    }
  } catch (err) {
    log.error("connect.challenge.wallet_ownership_proof_failed", {
      reason: err instanceof Error ? err.message : String(err),
    });
  }
}
